import { render, staticRenderFns } from "./BotaoMonitoramento.vue?vue&type=template&id=4d4bb874&lang=pug"
import script from "./BotaoMonitoramento.vue?vue&type=script&lang=js"
export * from "./BotaoMonitoramento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports